import {createHandler} from "./utils/createHandler";

export class BookingAPI{
    static add = createHandler("/booking/addBooking")
    static delete = createHandler("/booking/deleteBooking")
    static list = createHandler("/booking/bookings")
    static getMember = createHandler("/booking/getMemberById")
}

export const addBooking = createHandler("/booking/addBooking")
export const deleteBooking = createHandler("/booking/deleteBooking")
export const getBookingsAsync = createHandler("/booking/bookings")
export const getBookings = createHandler(`/booking/bookings`, "GET")
export const getMemberById = createHandler(`/booking/getMemberById`)
